import { connect } from 'react-redux'
import SettingsMenuItems from '../components/SettingsMenuItems'

const mapStateToProps = (state, ownProps) => {
  const { width } = state.window
  const { user } = state.authentication
  const { language } = state.user
  return ({
    width,
    user,
    language
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SettingsMenuItems)


// WEBPACK FOOTER //
// ./src/Pages/Settings/containers/SettingsMenuItems.js